import Banner from '../../ui/Banner';
import { AboutPageWrapper } from './styles';
import { AboutUsAboutDynamicDynamicZone, Testimony } from '../../../types/schema';
import DynamicZones from '../DynamicZones';

export type AboutPageTemplateProps = {
  metaTitle?: string;
  metaDescription?: string;
  metaImage?: string;
  hideAppMastersTitle?: boolean;
  title: string;
  description?: string;
  bannerUrl: string;
  aboutDynamic: AboutUsAboutDynamicDynamicZone[];
  testimonies?: Testimony[];
};

/**
 * AboutPageTemplate
 */
const AboutPageTemplate: React.FC<AboutPageTemplateProps> = ({
  title,
  description,
  bannerUrl,
  aboutDynamic,
  testimonies,
}) => {
  return (
    <AboutPageWrapper>
      <Banner title={title} description={description} imageUrl={bannerUrl} type="secondary" />
      <DynamicZones dynamicZones={aboutDynamic} allTestimonies={testimonies} />
    </AboutPageWrapper>
  );
};

export default AboutPageTemplate;
